import { parsePhoneNumberFromString } from 'libphonenumber-js';
export const DEFAULT_COUNTRY = 'IN';
export function normalisePhone(input, country = DEFAULT_COUNTRY) {
    const trimmed = (input ?? '').trim();
    if (trimmed === '')
        return { e164: '', country: null, isValid: false };
    const parsed = parsePhoneNumberFromString(trimmed, country);
    if (parsed && parsed.isValid()) {
        return { e164: parsed.number, country: parsed.country ?? country, isValid: true };
    }
    // Deliberate: an unrecognised number is stored as typed and flagged, never rejected.
    return { e164: trimmed, country, isValid: false };
}
export function formatPhone(e164) {
    const trimmed = (e164 ?? '').trim();
    if (trimmed === '')
        return '';
    const parsed = parsePhoneNumberFromString(trimmed);
    return parsed?.isValid() ? parsed.formatNational() : trimmed;
}
/** Digits only, with country code and no plus — the format wa.me expects. */
export function toWhatsAppNumber(e164) {
    return (e164 ?? '').replace(/\D/g, '');
}
//# sourceMappingURL=phone.js.map